import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'recent_tools'
const MAX_RECENT = 8

interface RecentEntry {
  href: string
  timestamp: number
}

export const useRecentTools = () => {
  const [recentHrefs, setRecentHrefs] = useState<string[]>([])

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const entries: RecentEntry[] = JSON.parse(stored)
      setRecentHrefs(entries.map(e => e.href))
    }
  }, [])

  const trackTool = useCallback((href: string) => {
    const stored = localStorage.getItem(STORAGE_KEY)
    let entries: RecentEntry[] = stored ? JSON.parse(stored) : []
    // Remove existing entry for this tool
    entries = entries.filter(e => e.href !== href)
    // Add to front
    entries.unshift({ href, timestamp: Date.now() })
    // Keep only MAX_RECENT
    entries = entries.slice(0, MAX_RECENT)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
    setRecentHrefs(entries.map(e => e.href))
  }, [])

  return { recentHrefs, trackTool }
}
